import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalStateService } from '@app/core/services/global-state.service';
import { IDocumentData } from '@app/transactions/components/upload-document/upload-document.component';
import { upload_transaction_model } from './upload-transaction-model';

@Component({
    selector: 'app-upload-transaction',
    templateUrl: './upload-transaction.component.html',
    styleUrls: ['./upload-transaction.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadTransactionComponent {
    public validable_type: string = 'transaction';
    public upload_transaction: Array<IDocumentData> = upload_transaction_model;
    public objectId: string = '';
    public beforepath: string = 't';
    public section: string = 'transaction';
    public beforepathCreate: string | undefined = undefined;

    public constructor(private activatedRoute: ActivatedRoute, private router: Router, private globalStateService: GlobalStateService) {
        this.activatedRoute.data.subscribe((data) => {
            let url: Array<string> = this.router.url.split('/');
            if (data && data.section && data.section === 'dashboard') {
                this.section = 'dashboard';
                this.objectId = url[4];
                this.beforepathCreate = 'users/' + this.globalStateService.userId;
                this.beforepath = 'users/' + this.globalStateService.userId + '/transactions/' + url[4];
            } else {
                this.objectId = url[3];
            }
        });
    }
}
